import { createFileRoute } from '@tanstack/react-router';

import { getLocalizedTitle } from '../title';

export const Route = createFileRoute('/_app/clients/representatives/')({
  head: () => ({
    meta: [
      {
        title: getLocalizedTitle('common.representatives', 'Representatives'),
      },
    ],
  }),
});
